import AppUser from './AppUser';

export default AppUser;
